import React, { createContext, ReactNode, useRef } from "react";

type GroupRef = { controller: AbortController };

interface Ctx {
  getGroup: (key: string) => GroupRef;
  abortAll: (key: string) => void;
}

export const CancellableRequestGroupContext = createContext<Ctx | undefined>(
  undefined
);

export function CancellableRequestGroupProvider({
  children,
}: {
  children: ReactNode;
}) {
  const groups = useRef(new Map<string, GroupRef>());

  const getGroup = (key: string): GroupRef => {
    let ref = groups.current.get(key);
    if (!ref) {
      ref = { controller: new AbortController() };
      groups.current.set(key, ref);
    }
    return ref;
  };

  const abortAll = (key: string) => {
    const ref = getGroup(key);
    ref.controller.abort();
    ref.controller = new AbortController();
  };

  return (
    <CancellableRequestGroupContext.Provider value={{ getGroup, abortAll }}>
      {children}
    </CancellableRequestGroupContext.Provider>
  );
}
